
const ApiService = Shopware.Classes.ApiService;

class SellopsUpsellApiService extends ApiService {
    constructor(httpClient, loginService, apiEndpoint = 'sellops') {
        super(httpClient, loginService, apiEndpoint);
        this.name = 'sellopsUpsellApiService';
    }

    /**
     * @param {string|null} [salesChannelId] Optional filter — when set, the
     *   server returns rules scoped to that sales channel plus any global
     *   rules (salesChannelId=null).
     */
    getRules(salesChannelId = null) {
        const config = { headers: this.getBasicHeaders() };
        if (salesChannelId) {
            config.params = { salesChannelId };
        }

        return this.httpClient
            .get('/sellops/upsell-rules', config)
            .then(ApiService.handleResponse.bind(ApiService));
    }

    createRule(rule) {
        return this.httpClient
            .post('/sellops/upsell-rules', rule, {
                headers: this.getBasicHeaders(),
            })
            .then(ApiService.handleResponse.bind(ApiService));
    }

    updateRule(id, rule) {
        return this.httpClient
            .put(`/sellops/upsell-rules/${id}`, rule, {
                headers: this.getBasicHeaders(),
            })
            .then(ApiService.handleResponse.bind(ApiService));
    }

    deleteRule(id) {
        return this.httpClient
            .delete(`/sellops/upsell-rules/${id}`, {
                headers: this.getBasicHeaders(),
            })
            .then(ApiService.handleResponse.bind(ApiService));
    }

    /**
     * @param {string[]} ids UUIDs in the desired display order — the server
     *   assigns `priority = index_in_array` to each.
     */
    reorderRules(ids) {
        return this.httpClient
            .post('/sellops/upsell-rules/reorder', { ids }, {
                headers: this.getBasicHeaders(),
            })
            .then(ApiService.handleResponse.bind(ApiService));
    }

    /**
     * @param {object} params
     * @param {string} params.dateFrom  YYYY-MM-DD
     * @param {string} params.dateTo    YYYY-MM-DD
     * @param {number} [params.page=1]  1-based page
     * @param {number} [params.limit=10]
     */
    getAnalytics({ dateFrom, dateTo, page = 1, limit = 10 }) {
        return this.httpClient
            .get('/sellops/upsell-analytics', {
                params: { dateFrom, dateTo, page, limit },
                headers: this.getBasicHeaders(),
            })
            .then(ApiService.handleResponse.bind(ApiService));
    }

    getSupportedPaymentMethods() {
        return this.httpClient
            .get('/sellops/upsell-supported-payment-methods/info', {
                headers: this.getBasicHeaders(),
            })
            .then(ApiService.handleResponse.bind(ApiService));
    }
}

export default SellopsUpsellApiService;
